import { render, staticRenderFns } from "./ProjectTypeSetting.vue?vue&type=template&id=21734723&scoped=true"
import script from "./ProjectTypeSetting.vue?vue&type=script&lang=js"
export * from "./ProjectTypeSetting.vue?vue&type=script&lang=js"
import style0 from "./ProjectTypeSetting.vue?vue&type=style&index=0&id=21734723&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21734723",
  null
  
)

export default component.exports